import React, { memo, useState, useEffect } from 'react'

import { Box, Flex, Skeleton, Tooltip, useToast } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { createNewDsrPage, createPlaceholderDuplicateDsrPage } from '../helpers/dsr-feed-helpers'
import { RiQuestionFill } from 'react-icons/ri'

import { useParams, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { displayReactIcon } from '../helpers/dsr-display-helpers'
import { SortableCustomPageMenuTab } from './page-designer/SortableCustomPageMenuTab'

import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import {
  restrictToWindowEdges,
  restrictToVerticalAxis
} from '@dnd-kit/modifiers';
import { duplicateDsrPage, resetDuplicateDsrPage } from '../actions/duplicate-dsr-page-actions'
import { triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import { IoSettingsOutline } from 'react-icons/io5'
import { DefaultPageSettingsModal } from './page-designer/DefaultPageSettingsModal'
import SpecialPageSettingsModal from './page-designer/SpecialPageSettingsModal';


function DsrDraftSideMenu({
  isRoomTemplate,
  pageArray,
  extraHeaderLayoutOffset,
  selectedDisplayPageId,
  selectedDisplaySubpage,
  handleSelectSubpage,
  addNewDsrPage,
  removeDsrPage,
  replaceDsrPages,
  isDsrAdmin,
  duplicateDsrPage,
  resetDuplicateDsrPage,
  duplicatedDsrPageOutcome,
  dsrBrandingOptions,
  altPageNames,
  isMobileView,
  applyBranding
  // closeMenuDrawer TODO: Implement this only when drafting DSR is allowed in mobile view
}) {
  const toast = useToast();
  const { dsrId } = useParams()
  const [activeId, setActiveId] = useState(null);

  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [brandColor, setBrandColor] = useState(null);
  const [editPageId, setEditPageId] = useState("")

  const handleClickDefaultPageSettingsModal = (pageId) => {
    setEditPageId(pageId)
    setShowSettingsModal(true)
  }

  const handleClickSpecialPageSettingsModal = (pageType) => {
    setEditPageId(pageType)
    setShowSettingsModal(true)
  }

  const handleCloseModal = () => {
    setEditPageId("")
    setShowSettingsModal(false)
  }

  useEffect(() => {
    if (dsrBrandingOptions) {
      const { primaryColor } = dsrBrandingOptions || {}
      setBrandColor(primaryColor)
    }
  }, [dsrBrandingOptions]);

  useEffect(() => {
    if (duplicatedDsrPageOutcome && pageArray) {
      const { successfulPageDuplication, duplicatedPage } = duplicatedDsrPageOutcome || {}

      if (!!successfulPageDuplication) {
        const { pageTitle, pageId } = duplicatedPage || {};
        if (pageId && Array.isArray(pageArray)) {
          const foundPageIndex = pageArray?.findIndex(page => page.pageId === pageId)
          if (foundPageIndex !== -1) {
            pageArray[foundPageIndex] = duplicatedPage;
            replaceDsrPages([...pageArray])
          }
        }
        toast(
          triggerLaunchdeckToast({
            useCase: "show-success-state",
            label: `${pageTitle} duplicated`,
            isMobileView
          })
        )
      } else if (successfulPageDuplication === false) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: `Unfortunately your page cannot be duplicated. Please try again later.`,
            isMobileView
          })
        )
      }

      resetDuplicateDsrPage()
    }
  }, [duplicatedDsrPageOutcome, isMobileView]);

  const sensors = useSensors(
    useSensor(PointerSensor),
  );

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = (event) => {
    setActiveId(null);
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const pagesIdArray = pageArray.map(tab => { return tab.pageId })
      const activeIndex = pagesIdArray.indexOf(active.id);
      const overIndex = pagesIdArray.indexOf(over.id);
      const sortedPages = arrayMove(pageArray, activeIndex, overIndex)

      if (sortedPages) {
        replaceDsrPages(sortedPages)
      }
    }
  };

  function renderSubPageTabs(category) {
    let pagesToRender = [];

    if (!pageArray) {
      return null
    }

    if (category === 'essential-pages') {
      pagesToRender = pageArray?.filter(tabs => tabs.pageType !== 'customised-page' && tabs.pageType !== 'faq') // Note: tabs.pageType !== 'faq' to help with backward compatiblity. Remove after faq pageType removed from DB
    } else if (category === 'custom-pages') {
      pagesToRender = pageArray?.filter(tabs => tabs.pageType === 'customised-page')
    }

    if (pagesToRender) {
      const pageTabs = pagesToRender?.map((tabs, tabIndex) => {
        const { pageId, pageTitle, altPageTitle, pageType } = tabs || {};

        if (pageType === 'customised-page') {
          return (
            <SortableCustomPageMenuTab
              key={pageId}
              tabs={tabs}
              tabIndex={tabIndex}
              selectedDisplayPageId={selectedDisplayPageId}
              handleSelectSubpage={handleSelectSubpage}
              handleRemovePageClick={handleRemovePageClick}
              handleEditPageData={handleEditPageData}
              handleDuplicatePageClick={handleDuplicatePageClick}
              dsrBrandingOptions={dsrBrandingOptions}
              applyBranding={applyBranding}
            />
          )
        }

        if (tabIndex === 0) {
          return (
            <React.Fragment key={`dsr_page_tab_${tabIndex}-${pageId}`}>
              <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
                className={(selectedDisplayPageId === `${pageId}`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
                onClick={() => handleSelectSubpage(pageId, "")}
              >
                <Box color={applyBranding && brandColor}>{displayReactIcon(pageType, '1em')}</Box>
                <Box ml='1em' whiteSpace='pre'>{pageTitle}</Box>
              </Flex>

              {!isRoomTemplate && updatesPageTab()}
            </React.Fragment>
          )

        } else {
          const isThisTab = (editPageId === pageId) ? true : false
          return (
            <Flex
              key={`dsr_page_tab_${tabIndex}-${pageId}`}
              justify='space-between' align='center' px='1.1em' py='0.875em'
              className={(selectedDisplayPageId === `${pageId}`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
              onClick={() => handleSelectSubpage(pageId, "")}
              gap={4}
              _hover={{
                ".show-icon-on-hover": {
                  visibility: "visible"
                }
              }}
            >
              <Flex justify='flex-start' align='center' gap='1em'>
                <Box color={applyBranding && brandColor}>{displayReactIcon(pageType, '1em')}</Box>
                <Box>{altPageTitle || pageTitle}</Box>
              </Flex>

              <Box className={(isThisTab && showSettingsModal) ? "show-icon-on-chosen" : "show-icon-on-hover"} onClick={() => handleClickDefaultPageSettingsModal(pageId)}>
                <Box as={IoSettingsOutline} color={'#171b21'} boxSize="1em" py='3%' />
              </Box>

              {
                (editPageId === pageId) && showSettingsModal &&
                <DefaultPageSettingsModal
                  pageId={pageId}
                  pageTitle={altPageTitle || pageTitle}
                  handleClosePageSettingsModal={handleCloseModal}
                  handleEditPageData={handleEditPageData}
                />
              }
            </Flex>
          )
        }
      })

      return (
        <>
          <DndContext
            sensors={sensors}
            onDragEnd={handleDragEnd}
            onDragStart={handleDragStart}
            modifiers={[restrictToVerticalAxis]}
          >
            <SortableContext items={pagesToRender.map(tab => { return tab.pageId })} strategy={verticalListSortingStrategy}>
              {pageTabs}
              <DragOverlay modifiers={[restrictToWindowEdges]}>
                {activeId ? (
                  <Skeleton height="20px" my="10px" />
                ) : null}
              </DragOverlay>
            </SortableContext>
          </DndContext>
        </>
      );

    } else return null
  }

  function handleCreateNewPageClick() {
    const newDsrPage = createNewDsrPage() // For UX: To make it appear instantly
    addNewDsrPage(newDsrPage, "")
    // Add function to add new object to DB
    handleSelectSubpage(newDsrPage.pageId, "") // Defaults to this new subpage
  }

  function handleRemovePageClick(pageId) {
    removeDsrPage(pageId)
    handleSelectSubpage("", "overview-subpage") // Defaults back to overview page when page removed
  }

  function handleDuplicatePageClick(pageId) {
    const pageToCopy = Array.isArray(pageArray) && pageArray?.find(page => page.pageId === pageId)

    if (pageToCopy) {
      const newDsrPage = createPlaceholderDuplicateDsrPage(pageToCopy) // For UX: To make it appear instantly for the time being
      addNewDsrPage(newDsrPage, pageId)
      handleSelectSubpage(newDsrPage.pageId, "")

      duplicateDsrPage({
        newPageId: newDsrPage.pageId,
        duplicatedPageId: selectedDisplayPageId,
        pageToCopy,
        dsrId
      })
    }
  }

  const faqTab = () => {
    const { faq: faqAltPageName } = altPageNames || {};
    const isThisTab = (editPageId === "faq") ? true : false
    return (
      <Flex justify='space-between' align='center' px='1.1em' py='0.875em'
        className={(selectedDisplaySubpage === `faq-subpage`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
        onClick={() => {
          handleSelectSubpage("", 'faq-subpage')
          // closeMenuDrawer && closeMenuDrawer()
        }}
        gap='1em'
        _hover={{
          ".show-icon-on-hover": {
            visibility: "visible"
          }
        }}
      >

        <Flex justify='flex-start' align='center' gap='1em'>
          <Box color={applyBranding && brandColor}>{displayReactIcon('faq', '1em')}</Box>
          <Box>{faqAltPageName || "Q&A"}</Box>
        </Flex>

        <Box className={(isThisTab && showSettingsModal) ? "show-icon-on-chosen" : "show-icon-on-hover"} onClick={() => handleClickSpecialPageSettingsModal("faq")}>
          <Box as={IoSettingsOutline} color={'#171b21'} boxSize="1em" py='3%' />
        </Box>
        {
          isThisTab && showSettingsModal &&
          <SpecialPageSettingsModal
            dsrId={dsrId}
            pageType="faq"
            altPageNames={altPageNames}
            handleClosePageSettingsModal={handleCloseModal}
          />
        }
      </Flex>
    )
  }

  const docFolderTab = () => {
    const { sharedDocs: sharedDocsAltPageName } = altPageNames || {};
    const isThisTab = (editPageId === "sharedDocs") ? true : false
    return (
      <Flex justify='space-between' align='center' px='1.1em' py='0.875em'
        className={(selectedDisplaySubpage === `shared-docs-folder-subpage`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
        onClick={() => {
          handleSelectSubpage("", 'shared-docs-folder-subpage')
        }}
        gap={4}
        _hover={{
          ".show-icon-on-hover": {
            visibility: "visible"
          }
        }}
      >

        <Flex justify='flex-start' align='center' gap='1em'>
          <Box color={applyBranding && brandColor}>{displayReactIcon('folder', '1em')}</Box>
          <Box lineHeight='1.5em'>{sharedDocsAltPageName ? sharedDocsAltPageName : "Shared Documents"}</Box>
        </Flex>

        <Box className={(isThisTab && showSettingsModal) ? "show-icon-on-chosen" : "show-icon-on-hover"} onClick={() => handleClickSpecialPageSettingsModal("sharedDocs")}>
          <Box as={IoSettingsOutline} color={'#171b21'} boxSize="1em" py='3%' />
        </Box>

        {
          isThisTab && showSettingsModal &&
          <SpecialPageSettingsModal
            dsrId={dsrId}
            pageType="sharedDocs"
            altPageNames={altPageNames}
            handleClosePageSettingsModal={handleCloseModal}
          />
        }
      </Flex>
    )
  }


  const updatesPageTab = () => {
    return (
      <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
        className={(selectedDisplaySubpage === "updates-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
        onClick={() => handleSelectSubpage("", 'updates-subpage')}
      >
        <Box color={applyBranding && brandColor}>{displayReactIcon('star', '1em')}</Box>
        <Box lineHeight='1.5em' ml='1em' whiteSpace='pre'>Updates</Box>

      </Flex>

    )
  }

  const mutualActionPlanTab = () => {
    const { map: mapAltPageName } = altPageNames || {};
    const isThisTab = (editPageId === "map") ? true : false
    return (
      <Flex justify='space-between' align='center' px='1.1em' py='0.875em'
        className={(selectedDisplaySubpage === `action-list-subpage`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
        onClick={() => handleSelectSubpage("", 'action-list-subpage')}
        gap={4}
        _hover={{
          ".show-icon-on-hover": {
            visibility: "visible"
          }
        }}
      >
        <Flex justify='flex-start' align='center' gap='1em'>
          <Box color={applyBranding && brandColor}>{displayReactIcon('circle-check', '1em')}</Box>
          <Box lineHeight='1.5em'>{mapAltPageName ? mapAltPageName : "Mutual Action Plan"}</Box>
        </Flex>

        <Box className={(isThisTab && showSettingsModal) ? "show-icon-on-chosen" : "show-icon-on-hover"} onClick={() => handleClickSpecialPageSettingsModal("map")}>
          <Box as={IoSettingsOutline} color={'#171b21'} boxSize="1em" py='3%' />
        </Box>

        {
          isThisTab && showSettingsModal &&
          <SpecialPageSettingsModal
            dsrId={dsrId}
            pageType="map"
            altPageNames={altPageNames}
            handleClosePageSettingsModal={handleCloseModal}
          />
        }
      </Flex>
    )
  }

  const createNewPageTab = () => {
    return (
      <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
        mt='1em'
        color='brand.500'
        border='1px solid'
        borderColor='brand.100'
        rounded='0.5em'
        className='unchosen-subpage-option'
        onClick={() => handleCreateNewPageClick()}
      >
        {displayReactIcon('add-new-page', '1em')}
        <Box lineHeight='1.5em' ml='1em' whiteSpace='pre'>New Page</Box>

      </Flex>
    )
  }

  const categoryLabel = (labelText, toolTipText) => {
    return (
      <Flex mt={labelText === "CUSTOM PAGES" ? "2em" : '1em'} justify='flex-start' align='center' color='gray.500' cursor='default' className='unchosen-subpage-option'>
        <Box fontSize='0.75em' fontWeight='600' whiteSpace='pre'>{labelText}</Box>
        {toolTipText && <Tooltip fontSize='0.8em' label={toolTipText} placement="auto-start">
          <Box ml='0.5em'>
            <Box as={RiQuestionFill} boxSize="1em" py='3%' />
          </Box>
        </Tooltip>
        }
      </Flex>
    )
  }

  const templateCategoryLabel = () => {
    return (
      <Box mt='1em' className='template-default-pages-label'>
        <Flex justify='flex-start' align='center' color='gray.500' cursor='default' >
          <Box fontSize='0.75em' fontWeight='600' whiteSpace='pre'>DEFAULT PAGES</Box>
        </Flex>


        <Flex justify='flex-start' align='center' gap={2}>
          <Tooltip fontSize='0.8em' p='1em' minW='20em' whiteSpace='pre-wrap' label={`Updates & Mutual Action Plan are audience-specific pages. \n\nThey are available when editing Rooms made with this template.`} placement="auto-start">
            <Box fontSize='0.65em' fontWeight='400' color='gray.500' whiteSpace='pre'>Why are some pages unavailable?</Box>

          </Tooltip>
        </Flex>
      </Box>
    )
  }

  const handleEditPageData = (newPageData, pageId) => {
    const updatedPages = pageArray.map((page) => page.pageId === pageId ? { ...page, ...newPageData } : page);

    if (updatedPages) {
      replaceDsrPages(updatedPages)
    }
  }

  const renderAdminPageTabs = () => {
    return (
      <Box mb='2em'>
        <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "insights-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'insights-subpage')
          }}
        >
          {displayReactIcon('worktool', '1em')}
          <Box lineHeight='1.5em' ml='1em'> Insights</Box>

        </Flex>

        <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "team-notes-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'team-notes-subpage')
          }}
        >
          {displayReactIcon('worktool', '1em')}
          <Box lineHeight='1.5em' ml='1em'> Team Notes</Box>

        </Flex>

        <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "room-settings-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'room-settings-subpage')
          }}
        >
          {displayReactIcon('worktool', '1em')}
          <Box lineHeight='1.5em' ml='1em'> Settings</Box>

        </Flex>
      </Box>
    )
  }

  const renderTemplateAdminPageTabs = () => {
    return (
      <Box>
        {/* <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "team-notes-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'team-notes-subpage')
          }}
        >
          {displayReactIcon('worktool', '1em')}
          <Box lineHeight='1.5em' ml='1em'> Team Notes</Box>

        </Flex> */}

        <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "template-settings-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'template-settings-subpage')
          }}
        >
          {displayReactIcon('worktool', '1em')}
          <Box lineHeight='1.5em' ml='1em'> Settings</Box>

        </Flex>
      </Box>
    )
  }

  const renderTemplateDeactivatedTab = (type) => {
    let icon = "";
    let label = "";
    switch (type) {
      case ("overview"): {
        icon = "overview"
        label = "Overview"
        break;
      }
      case ("updates"): {
        icon = "star"
        label = "Updates"
        break;
      }
      case ("mutual-action-plan"): {
        icon = "circle-check"
        label = "Mutual Action Plan"
        break;
      }
      default: {
        break;
      }
    }
    return (
      <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
        className="deactivated-template-subpage-option">
        {displayReactIcon(icon, '1em')}
        <Box lineHeight='1.5em' ml='1em'> {label} </Box>
      </Flex>
    )
  }

  if (isRoomTemplate) {
    return (
      <Flex
        flexWrap='wrap'
        justify='flex-start'
        pt='3em'
        maxWidth='280px'
        height='calc(100vh - 140px)'
        overflowX="hidden"
        overflowY="auto"
        sx={{
          // Hides scrollerbar
          '&::-webkit-scrollbar': { display: 'none' },  // Chrome, Safari, Opera
          '-ms-overflow-style': 'none',                 // IE and Edge
          'scrollbar-width': 'none',                    // Firefox
        }}
      >
        <Box maxWidth='fit-content'>
          {/* {categoryLabel('DEFAULT PAGES', 'Essential pages for your Room')} */}
          {templateCategoryLabel()}
          {renderSubPageTabs('essential-pages')}

          {faqTab()}
          {docFolderTab()}

          {renderTemplateDeactivatedTab("updates")}
          {renderTemplateDeactivatedTab("mutual-action-plan")}

          {categoryLabel('CUSTOM PAGES', 'Create additional custom pages for your Room')}
          {renderSubPageTabs('custom-pages')}
          {createNewPageTab()}

        </Box>

        <React.Fragment>
          {isRoomTemplate ?
            <Box mt='2em'>
              {categoryLabel('MANAGE TEMPLATE', '')}
              {renderTemplateAdminPageTabs()}
            </Box>
            : isDsrAdmin &&
            <Box mt='2em'>
              {categoryLabel('ADMINISTRATOR PAGES', 'Info accessible only by Room Administrators')}
              {renderAdminPageTabs()}
            </Box>

          }

        </React.Fragment>
      </Flex>
    )
  } else {
    return (
      <Flex
        flexWrap='wrap'
        justify='flex-start'
        pt={extraHeaderLayoutOffset ? '2.5em' : '1.5em'}
        maxWidth='280px'
        height='calc(100vh - 140px)'
        overflowX="hidden"
        overflowY="auto"
        sx={{
          // Hides scrollerbar
          '&::-webkit-scrollbar': { display: 'none' },  // Chrome, Safari, Opera
          '-ms-overflow-style': 'none',                 // IE and Edge
          'scrollbar-width': 'none',                    // Firefox
        }}
      >
        <Box maxWidth='fit-content'>
          {categoryLabel('DEFAULT PAGES', 'Essential pages for your Room')}

          {renderSubPageTabs('essential-pages')}
          {faqTab()}
          {mutualActionPlanTab()}
          {docFolderTab()}

          {categoryLabel('CUSTOM PAGES', 'Create additional custom pages for your Room')}
          {renderSubPageTabs('custom-pages')}
          {createNewPageTab()}

        </Box>


        {(isDsrAdmin && !isRoomTemplate) &&
          <Box mt='2em'>
            {categoryLabel('ADMINISTRATOR PAGES', 'Info accessible only by Room Administrators')}
            {renderAdminPageTabs()}
          </Box>
        }


      </Flex>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
    selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
    duplicatedDsrPageOutcome: state.duplicateDsrPageOutcome.results,
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
    dsrBrandingOptions: state.dsrBrandingOptions.results,
    isMobileView: state.mobileViewMode.isMobileView,
    applyBranding: state.dsrApplyBranding.results
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      duplicateDsrPage,
      resetDuplicateDsrPage
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrDraftSideMenu)))
